import { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';

function BotonAcciones(row, Editar) {
    return (
        <div>
            <div className="btn-group">
                <button type="button" className="btn btn-info" onClick={() => Editar(row)} 
                    data-tooltip-id='tooltiparriba'
                    data-tooltip-content="Editar">
                    <FaArrowAltCircleRight/>
                </button>
            </div>
        </div>
    );
}

export default function PaginaModulos(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState([]);
    const { handleSubmit, register, setValue } = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [nombreComponente] = useState('paginas modulos');
    const columns = [
        {
            name: 'Acciones',
            cell: row => BotonAcciones(row, Editar),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, filterable: true },
        { name: 'Nombre', selector: row => row.pmoNombre, sortable: true, filterable: true },
        { name: 'Carpeta', selector: row => row.pmoCarpeta, sortable: true, filterable: true },
        { name: 'Descripcion', selector: row => row.pmoDescripcion, sortable: true, filterable: true },
        { name: 'Icono', selector: row => row.pmoIcono, sortable: true, filterable: true },
        { name: 'Padre ID', selector: row => row.pmoPadreid, sortable: true, filterable: true },
        { 
            name: 'Habilitado', 
            selector: row => row.pmoEnabled ? 'Activo' : 'Inactivo', 
            sortable: true, 
            filterable: true 
        },
    ];
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = '/parametros/listarpaginamodulos';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('Nuevo', false);
        setValue('pmoNombre', row.pmoNombre);
        setValue('pmoCarpeta', row.pmoCarpeta);
        setValue('pmoDescripcion', row.pmoDescripcion);
        setValue('pmoIcono', row.pmoIcono);
        setValue('pmoPadreid', row.pmoPadreid);
        setValue('pmoEnabled', row.pmoEnabled);
    }
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('Nuevo', true);
        setValue('pmoNombre', '');
        setValue('pmoCarpeta', '');
        setValue('pmoDescripcion', '');
        setValue('pmoIcono', '');
        setValue('pmoPadreid', 0);
        setValue('pmoEnabled', true);
        setMuestraFormulario(1);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarpaginamodulo';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('Nuevo', true);
        setValue('pmoNombre', '');
        setValue('pmoCarpeta', '');
        setValue('pmoDescripcion', '');
        setValue('pmoIcono', '');
        setValue('pmoPadreid', 0);
        setValue('pmoEnabled', 0);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title={nombreComponente}
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Parametros"
                nombreform={nombreComponente}
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario {nombreComponente}</h3>
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <div className="row">
                                        <input hidden {...register('id')}/>
                                        <input hidden {...register('Nuevo')}/>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pmoNombre">Nombre</label>
                                                <input 
                                                    id="pmoNombre"
                                                    type="text" 
                                                    className="form-control" 
                                                    {...register('pmoNombre')} 
                                                    placeholder="Ingrese el nombre"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pmoCarpeta">Carpeta</label>
                                                <input 
                                                    id="pmoCarpeta"
                                                    type="text" 
                                                    className="form-control" 
                                                    {...register('pmoCarpeta')} 
                                                    placeholder="Ingrese la carpeta"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pmoDescripcion">Descripci&oacute;n</label>
                                                <textarea 
                                                    id="pmoDescripcion"
                                                    className="form-control" 
                                                    {...register('pmoDescripcion')} 
                                                    placeholder="Ingrese la descripci&oacute;n"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pmoIcono">Icono</label>
                                                <input 
                                                    id="pmoIcono"
                                                    type="text" 
                                                    className="form-control" 
                                                    {...register('pmoIcono')} 
                                                    placeholder="Ingrese el icono"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pmoPadreid">Padre ID</label>
                                                <input 
                                                    id="pmoPadreid"
                                                    type="number" 
                                                    className="form-control" 
                                                    {...register('pmoPadreid')} 
                                                    placeholder="Ingrese el ID del padre"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pmoEnabled">Habilitado</label>
                                                <select 
                                                    id="pmoEnabled"
                                                    className="form-control" 
                                                    {...register('pmoEnabled')}
                                                >
                                                    <option value={1}>S&iacute;</option>
                                                    <option value={0}>No</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                    </div>
                                </div>
                                <DataTable
                                    title={`Lista de ${nombreComponente}`}
                                    columns={columns}
                                    data={datos}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}